import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoLocation } from '@smg-real-estate/geo-libs';

export function getDisplayValue(locationNames: string[]): string {
  // Usually, in the case of multiple location names, the first one is a zip code
  // and the rest are location names for the zip code. e.g. ['8003', 'Zurich']
  // however it can also be a name  ['Geneva', 'Genève'] or ['Zurich', 'Zürich']

  const [first, ...rest] = locationNames;
  if (!first) {
    return '';
  }
  return first + (rest.length ? ` (${rest.join(', ')})` : '');
}

const showTypeLabel = (location: GeoLocation) => ['canton', 'region'].includes(location.type);

export const getDistinguishedDisplayValue = (
  geoLocation: GeoLocation,
  language: HgSupportedLanguage,
  options: { inclAllNames: boolean } = { inclAllNames: false },
): string => {
  const names: string[] = options.inclAllNames
    ? geoLocation.names[language]
    : [geoLocation.names[language][0]];
  return [
    showTypeLabel(geoLocation) ? geoLocation.typeLabel?.[language] : undefined,
    getDisplayValue(names),
  ]
    .filter((x) => !!x)
    .join(' ');
};
